export default __webpack_public_path__ + "static/media/mp_assistance.386d90ef.svg";